export default __webpack_public_path__ + "static/media/step1.d9ad31d3.svg";